import { get } from "@/utils/request"; // 导入模块

// 名企首页 行业列表
export const getIndustryList = (params) =>
  get("Api/ClientRecruitment/GetIndustryList", params);

// 名企首页 最新网申
export const getNewRecruitmentJobList = (params) =>
  get("Api/ClientRecruitment/GetClientRecruitmentJobList", params);

// 名企首页 特别推荐
export const getWellCompany = (params) =>
  get("Api/ClientRecruitment/GetClientRecruitmentList", params);






// // 名企首页 行业列表
// export const getIndustryList = (params) =>
//   get("api/Api/ClientRecruitment/GetIndustryList", params);

// // 名企首页 最新网申
// export const getNewRecruitmentJobList = (params) =>
//   get("api/Api/ClientRecruitment/GetClientRecruitmentJobList", params);

// // 名企首页 特别推荐
// export const getWellCompany = (params) =>
//   get("api/Api/ClientRecruitment/GetClientRecruitmentList", params);
